/**
 * Biolane Collection Dark Mode
 * Animation Longines - 4 phases
 * 
 * Logique :
 * - isNightMode = false (défaut) → images normales (jour), lune visible
 * - isNightMode = true → images metafield (nuit), soleil visible
 */

(function() {
  'use strict';
  
  // Mode JOUR par défaut (lune visible)
  let isNightMode = false;

  
  
  function init() {
    updateCollectionImages(isNightMode);
    updateAllToggles(isNightMode);
    initHeaderToggle();
    initMobileToggle();
  }
  
  /**
   * Met à jour les images de la collection
   * isNight = false → images normales (jour)
   * isNight = true → images metafield (nuit)
   */
  function updateCollectionImages(isNight) {
    // Variantes produits
    document.querySelectorAll('.card-wrapper[data-is-night-product="true"]').forEach((card) => {
      const dayImage = card.querySelector('.card-image--day');
      const nightImage = card.querySelector('.card-image--night');
      
      if (dayImage && nightImage) {
        dayImage.style.opacity = isNight ? '0' : '1';
        nightImage.style.opacity = isNight ? '1' : '0';
        nightImage.style.pointerEvents = isNight ? 'auto' : 'none';
      }
    });
    
    // Push marketing
    document.querySelectorAll('.card-push-wrapper.has-night-mode').forEach((push) => {
      const dayImage = push.querySelector('.card-push-image--day');
      const nightImage = push.querySelector('.card-push-image--night');
      
      if (dayImage && nightImage) {
        dayImage.style.opacity = isNight ? '0' : '1';
        nightImage.style.opacity = isNight ? '1' : '0';
        nightImage.style.pointerEvents = isNight ? 'auto' : 'none';
      }
    });
  }
  
  function setNightMode(isNight) {
    isNightMode = isNight;
    updateCollectionImages(isNight);
    updateAllToggles(isNight);
    
    window.dispatchEvent(new CustomEvent('darkModeChange', {
      detail: { isNightMode: isNight }
    }));
  }
  
  function toggleMode() {
    setNightMode(!isNightMode);
  }
  
  /**
   * Met à jour tous les toggles (Animation Longines)
   */
  function updateAllToggles(isNight) {
    const mode = isNight ? 'night' : 'day';
    
    // Toggle header desktop (ancien style si présent)
    document.querySelectorAll('.collection-header-dark-mode').forEach(toggle => {
      toggle.dataset.mode = mode;
      const label = toggle.querySelector('.collection-header-dark-mode__label');
      if (label) {
        label.textContent = isNight ? 'jour' : 'nuit';
      }
    });
    
    // Toggles Longines
    document.querySelectorAll('.dark-mode-toggle').forEach(toggle => {
      toggle.dataset.mode = mode;
      
      const wrapper = toggle.querySelector('.NightModeButton_Wrapper');
      const sunIcon = toggle.querySelector('.NightModeButton_Icon__Sun');
      const moonIcon = toggle.querySelector('.NightModeButton_Icon__Moon');
      
      if (wrapper) {
        wrapper.classList.toggle('NightModeButton_Wrapper--active', isNight);
        wrapper.setAttribute('aria-pressed', isNight ? 'true' : 'false');
      }
      
      if (sunIcon) {
        sunIcon.classList.toggle('NightModeButton_Icon__Sun--visible', isNight);
      }
      
      if (moonIcon) {
        moonIcon.classList.toggle('NightModeButton_Icon__Moon--hidden', isNight);
      }
    });
  }
  
  function initHeaderToggle() {
    document.querySelectorAll('.collection-header-dark-mode').forEach((toggle) => {
      toggle.dataset.mode = isNightMode ? 'night' : 'day';
      
      const button = toggle.querySelector('.collection-header-dark-mode__button');
      if (button) {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          toggleMode();
        });
      }
    });
  }
  
  function initMobileToggle() {
    // Ancien sélecteur
    document.querySelectorAll('.dark-mode-toggle--mobile-facets').forEach((toggle) => {
      const button = toggle.querySelector('.dark-mode-toggle__button');
      if (button) {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          toggleMode();
        });
      }
    });
    
    // Nouveau sélecteur Longines
    document.querySelectorAll('.dark-mode-toggle--collection-mobile, .dark-mode-toggle--collection-desktop').forEach((toggle) => {
      const button = toggle.querySelector('.NightModeButton_Wrapper');
      if (button && !button.dataset.collectionInitialized) {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          toggleMode();
        });
        button.dataset.collectionInitialized = 'true';
      }
    });
  }
  
  window.BiolaneCollectionDarkMode = {
    getNightMode: function() { return isNightMode; },
    setNightMode: setNightMode,
    toggleMode: toggleMode,
    updateCollectionImages: updateCollectionImages
  };
  
  window.addEventListener('darkModeChange', function(e) {
    if (e.detail && typeof e.detail.isNightMode !== 'undefined') {
      updateAllToggles(e.detail.isNightMode);
    }
  });
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
